import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { AutoPayment } from "../../services/ReduxTookit/Slice/InvoiceRedux";
import { getCardBrandImage } from "../../services/CommonServices";
import billingsplans from "../../assets/images/billingsplans.svg";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const ChoosePaymentMethodModel = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const PrimarycardId = props?.paymentMethodList?.filter(
    (item) => item?.isprimary && item?.paymentmethodid
  );

  const [selectedPaymentId, setSelectedPaymentId] = useState(
    PrimarycardId[0]?.paymentmethodid
  );

  const fnMakePayment = async () => {
    setLoading(true);
    try {
      const body = {
        amount: props?.requestObj?.reqObj.amount,
        paymentmethodid: selectedPaymentId,
        associationid: props?.requestObj?.reqObj.associationid,
        associationtype: "Workflow Invoice",
      };
      const resp = await dispatch(AutoPayment(body));
      if (
        resp &&
        resp.payload &&
        resp.payload.isValidate &&
        resp.payload.data
      ) {
        if (resp.payload.data.status_code === 1) {
          let tmpData = props.CostwidgetList;
          tmpData?.forEach((element) => (element.status_term = "Paid"));
          props.setCostwidgetList(tmpData);
          toast.success(resp.payload.data.message);
          props.onHide();
        }
      } else {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      toast.error("Something went wrong.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className="dashboard-pay-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Choose Payment Method
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="setting-payment-method">
          <Row>
            {props?.paymentMethodList &&
              props?.paymentMethodList?.length > 0 && (
                <>
                  {props?.paymentMethodList?.map((item) => {
                    let DisplayNo = item.methodnumber;
                    if (item.methodnumber) {
                      if (item.methodnumber.length < 16) {
                        for (let i = item.methodnumber.length; i < 16; i++) {
                          DisplayNo = "X" + DisplayNo;
                        }
                      }
                    } else {
                      DisplayNo = "XXXXXXXXXXXXXXXX";
                    }
                    DisplayNo =
                      "XXXX-XXXX-XXXX-" +
                      DisplayNo.substr(DisplayNo.length - 4, DisplayNo.length);
                    return (
                      <Col
                        xl={6}
                        className={`${
                          item?.paymentmethodid === selectedPaymentId &&
                          "active-payment"
                        }`}
                        onClick={() =>
                          setSelectedPaymentId(item?.paymentmethodid)
                        }
                      >
                        <div className="main-payment-method cursor-pointer">
                          <div className="common-white-bg bcmtop-main payment-method billing-listing-payment-method h-auto">
                            <div className="payment-method-detail d-block">
                              <div className="payment-method-detail-img mb-2">
                                {/* {item.brand?.toUpperCase()} */}

                                {item?.display_brand &&
                                  getCardBrandImage(item?.display_brand)}
                              </div>
                              <div className="payment-method-detail-data d-flex justify-content-between align-items-end">
                                <div className="payment-method-detail-data-block">
                                  <div className="visa-title card-paymeant ">
                                    <h4>{item.methodtype?.toUpperCase()}</h4>
                                    {item.isprimary ? (
                                      <span className="cursor-pointer bg-success text-white">
                                        <b>Primary</b>
                                      </span>
                                    ) : (
                                      <>
                                        {/* <span
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setPrimaryConfirmation(true);
                                    setPaymentMethodIDForPrimary(
                                      item?.paymentmethodid
                                    );
                                  }}
                                >
                                  <b>Set Primary</b>
                                </span> */}
                                      </>
                                    )}
                                  </div>
                                  <p>
                                    {item.display_brand
                                      ?.replaceAll(/_/g, " ")
                                      ?.toUpperCase()}{" "}
                                    {item.category?.toUpperCase()}{" "}
                                    {item.methodtype?.toUpperCase()}
                                  </p>
                                  <div>
                                    <img
                                      style={{ width: "14px", height: "14px" }}
                                      src={billingsplans}
                                      alt="billingsplans"
                                    />
                                    <span className="ms-1">{DisplayNo}</span>
                                  </div>
                                </div>
                                {/* {item.isprimary ? (
                            <></>
                          ) : (
                            <div
                              className="payment-method-detail-data-block-delete cursor-pointer"
                              onClick={() => {
                                setModalShow(true);
                                setDeletePayload({
                                  id: item?.paymentmethodid,
                                });
                              }}
                            >
                              <img src={deleteaction} alt="deleteaction" />
                            </div>
                          )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </>
              )}
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="grey-btn w-auto"
          disabled={loading}
          onClick={props.onHide}
        >
          Close
        </button>
        <button
          className="blue-btn w-auto"
          disabled={loading}
          onClick={fnMakePayment}
        >
          Pay Now
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChoosePaymentMethodModel;
